import { formatDate, formatAmountParts } from '@mgonetwork/core';
import { Text, Heading } from '@mgonetwork/ui';
import { format, isToday, isYesterday } from 'date-fns';
import { useMemo } from 'react';

import { Checkpoint } from '~/components/HomeMetrics/Checkpoint';
import { useEpochProgress } from '~/pages/epochs/utils';
import { Card } from '~/ui/Card';
import { ProgressBar } from '~/ui/ProgressBar';
import { LinkWithQuery } from '~/ui/utils/LinkWithQuery';
import { ampli } from '~/utils/analytics/ampli';

export function CurrentEpoch() {
	const { epoch, progress, label, end, start } = useEpochProgress();

	const formattedDateString = useMemo(() => {
		if (!start) {
			return null;
		}

		let formattedDate = '';
		const epochStartDate = new Date(start);
		if (isToday(epochStartDate)) {
			formattedDate = 'Today';
		} else if (isYesterday(epochStartDate)) {
			formattedDate = 'Yesterday';
		} else {
			formattedDate = format(epochStartDate, 'PPP');
		}
		const formattedTime = format(epochStartDate, 'p');
		return `${formattedTime}, ${formattedDate}`;
	}, [start]);

	return (
		<LinkWithQuery
			to={`/epoch/${epoch}`}
			onClick={() => ampli.clickedCurrentEpochCard({ epoch: Number(epoch) })}
		>
			<Card growOnHover bg="definedBlack" height="full" spacing="lg">
				<div className="flex flex-col gap-2 text-hero-dark md:gap-6">
					<Heading color="defined-success-dark" variant="heading4/semibold">
						Epoch {formatAmountParts(epoch)}
					</Heading>
					<Text variant="pSubtitle/semibold" color="steel-dark">
						{!progress && end ? (
							`End ${formatDate(end)}`
						) : formattedDateString ? (
							<div className="relative -top-2">
								<p className="text-gr-dark text-heading6 md:text-heading3">{formattedDateString}</p>
								<p className="mt-1 text-caption font-semibold text-steel-darker">Started</p>
							</div>
						) : (
							'--'
						)}
					</Text>
					<div className="defined-bd-13 -mt-3.5 grow border-b" />
					<div className="-mt-3.5 flex items-center justify-between gap-6 space-y-1.5">
						<span className="text-caption font-semibold text-steel-darker">Time Remain</span>
						<Heading variant="heading6/medium" color="text-gr-dark">
							{label ?? '--'}
						</Heading>
						{/* <ProgressBar animate progress={progress || 0} /> */} {/*进度条*/}
					</div>
					<div className="defined-bd-13 -mt-2 grow border-b" />

					<Checkpoint />
				</div>
			</Card>
		</LinkWithQuery>
	);
}
